import Projects from "./utils/Projects";
import ProjectsInverse from "./utils/ProjectsInverse"
import AccordousImages from "./images/accordous.png";
import GenesisImages from "./images/genesis.png";
import Enterprises from "./Enterprises";
import Packages from "./Packages";
import {Translator} from "./i18n";


function Experience() {
    return (
        <div>
            <h1 className="text-center mb-6 font-sans font-bold tracking-tight text-gray-900 sm:text-4xl sm:leading-none py-16">
                <Translator path="projects.experience" />
            </h1>
            <Projects title={<Translator path="projects.accordous.enterprise" />}
                      className="container"
                      subtitle={<Translator path="projects.accordous.position" />}
                      description={<Translator path="projects.accordous.description" />}
                      image={AccordousImages}
            />
            <ProjectsInverse title={<Translator path="projects.genesis.enterprise" />}
                      className="container"
                      subtitle={<Translator path="projects.genesis.position" />}
                      description={<Translator path="projects.genesis.description" />}
                      image={GenesisImages}
            />
            <Enterprises />
            <Packages />
        </div>
    )
}

export default Experience
